import { DisplayedCarInfoInterface } from '@/types';
import { AvailableCTAs } from '../../CarCTAs/CarCTAs.enum';
import { CarProfileCTAs } from '../../CarCTAs/AvailableActions';
import SylndrButton from '@/components/shared/Button/button-styled.component';
import Typography from '@/components/shared/typography/typography.component';

const SylndrHelpCTAs = ({
    carInfo,
    onClick,
    ctaTitle,
}: {
    carInfo: DisplayedCarInfoInterface;
    onClick: () => void;
    ctaTitle: string;
}) => {
    const BookingComponent = CarProfileCTAs[AvailableCTAs.BOOKING];
    return (
        <div className="md:hidden w-full sticky bottom-0 bg-white px-3 py-4 shadow-[0px_24px_48px_-12px_rgba(16,24,40,0.18)] border-t border-[#EAECF0] z-[2] flex items-center gap-[14px] h-[98px]">
            <div className="w-1/2 h-12">
                <BookingComponent carInfo={carInfo} />
            </div>
            <div className="border border-gray-300 rounded-lg w-1/2">
                <SylndrButton
                    variant="outlined"
                    style={{ height: '48px' }}
                    onClick={onClick}
                >
                    <Typography>{ctaTitle}</Typography>
                </SylndrButton>
            </div>
        </div>
    );
};

export default SylndrHelpCTAs;
